import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';

const routes: Routes = [
    {
        path: 'tabs',
        component: TabsPage,
        children:
            [
                {
                    path: 'messages',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../messages/messages.module').then(m => m.MessagesPageModule)
                            }
                        ]
                },
                {
                    path: 'messages/channels',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../messages/messages.module').then(m => m.MessagesPageModule)
                            }
                        ]
                },
                {
                    path: 'messages/broadcast',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../messages/messages.module').then(m => m.MessagesPageModule)
                            }
                        ]
                },
                {
                    path: 'messages/channel/:channelId',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../messages/messages.module').then(m => m.MessagesPageModule)
                            }
                        ]
                },
                {
                    path: 'messages/direct/:participantId',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../messages/messages.module').then(m => m.MessagesPageModule)
                            }
                        ]
                },
                {
                    path: 'appointments',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../appointments/appointments.module').then(m => m.AppointmentsPageModule)
                            }
                        ]
                },
                {
                    path: 'appointments/:id',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../appointments/appointments.module').then(m => m.AppointmentsPageModule)
                            }
                        ]
                },
                {
                    path: 'home/:segment/:view',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardPageModule)
                            }
                        ]
                },
                {
                    path: 'ask-the-speaker',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../ask-the-speaker/ask-the-speaker.module').then(m => m.AskTheSpeakerPageModule)
                            }
                        ]
                },
                {
                    path: 'setting',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../setting/setting.module').then(m => m.SettingPageModule)
                            }
                        ]
                },
                {
                    path: 'edit-profile',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../edit-profile/edit-profile.module').then(m => m.EditProfilePageModule)
                            }
                        ]
                },
                {
                    path: 'event-key',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../event-key/event-key.module').then(m => m.EventKeyPageModule)
                            }
                        ]
                },
                {
                    path: 'access-key',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../event-key/event-key.module').then(m => m.EventKeyPageModule)
                            }
                        ]
                },
                {
                    path: 'keywords/:view',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../keywords/keywords.module').then(m => m.KeywordsPageModule)
                            }
                        ]
                },
                {
                    path: 'live-votings',
                    children:
                        [
                            {
                                path: '',
                                loadChildren: () => import('../live-votings/live-votings.module').then(m => m.LiveVotingsPageModule)
                            }
                        ]
                },
                {
                  path: 'credentials-wallet',
                  children:
                      [
                          {
                              path: '',
                              loadChildren: () => import('../credentials-wallet/credentials-wallet.module').then( m => m.CredentialsWalletPageModule)
                          }
                      ]
                },
                {
                    path: '',
                    redirectTo: '/home/info/matching',
                    pathMatch: 'full'
                }
            ]
    },
    {
        path: '',
        redirectTo: '/tabs/home/info/matching',
        pathMatch: 'full'
    }
];

@NgModule({
    imports:
        [
            RouterModule.forChild(routes)
        ],
    exports:
        [
            RouterModule
        ]
})
export class TabsPageRoutingModule { }
